import React, { useEffect, useState } from 'react';

function CountdownTimer({ targetDate, isActive }) {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    if (!isActive) return;

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate.getTime() - now;

      if (distance > 0) {
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate, isActive]);

  return (
    <div className="countdown-timer">
      <div className="time-unit">
        <span className="time-number">{timeLeft.days}</span>
        <span className="time-label">Jours</span>
      </div>
      <div className="time-unit">
        <span className="time-number">{timeLeft.hours}</span>
        <span className="time-label">Heures</span>
      </div>
      <div className="time-unit">
        <span className="time-number">{timeLeft.minutes}</span>
        <span className="time-label">Minutes</span>
      </div>
      <div className="time-unit">
        <span className="time-number">{timeLeft.seconds}</span>
        <span className="time-label">Secondes</span>
      </div>
    </div>
  );
}

export default CountdownTimer;
